import React, { useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import './Login.css';

const LoginPage = () => {
    const { setUser } = useContext(UserContext);
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const redirectTo = location.state?.redirectTo || '/';
    const warningMessage = location.state?.message || null;
    const verifyEmailMesage = location.state?.verifyEmailMesage || null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await fetch('https://3nrqnhje08.execute-api.us-east-2.amazonaws.com/api/Users/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error('Login failed');
            }

            const data = await response.json();
            console.log(data);
            if (data.isSuccess) {
                const userProfile = {
                    ...data.userProfileInfo,
                    expiry: new Date().getTime() + 3600000, // 1 hour expiration
                };
                setUser(userProfile);
                localStorage.setItem('user', JSON.stringify(userProfile));
                navigate(redirectTo);
            } else {
                setError(data.errorMessageUserValidation);
                if (data.isNoEmailVerificationError) {
                    setError(
                        <>
                            {data.errorMessageUserValidation}{' '}
                            <span
                                onClick={() => navigate('/resendEmailVerification')}
                                style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
                            >
                                Click Here
                            </span>{' '}
                            to resend your email verification email.
                        </>
                    );
                }
                setFormData({ email: '', password: '' });
            }
        } catch (err) {
            console.error('Error during login:', err);
            setError('Incorrect email or password.');
            setFormData({ email: '', password: '' }); // Clear the text boxes
        } finally {
            setLoading(false);
        }
    };

    const handleResetPassword = () => {
        navigate('/resetpassword');
    };

    const handleCreateAccount = () => {
        navigate('/signup', { state: { redirectTo } });
    };

    return (
        <div className="main-vla-container">
            <h2>Log In</h2>
            {warningMessage && (
                <div
                    className="login-warning-box"
                    style={{
                        color: '#721C24',
                        backgroundColor: '#F8D7DA', // Light red background
                        padding: '10px',
                        marginBottom: '20px',
                        borderRadius: '5px',
                        border: '1px solid #F5C6CB',
                    }}
                >
                    {warningMessage}
                </div>
            )}
            {verifyEmailMesage && (
                <div
                    className="login-warning-box"
                    style={{
                        color: '#155724',
                        backgroundColor: '#D4EDDA',
                        padding: '10px',
                        marginBottom: '20px',
                        borderRadius: '5px',
                        border: '1px solid #C3E6CB',
                    }}
                >
                    {verifyEmailMesage}
                </div>
            )}
            <form onSubmit={handleSubmit}>
                <div className="login-form-group">
                    <label>Email</label>
                    <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="login-form-group">
                    <label>Password</label>
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                    />
                </div>
                {error && <p className="login-error-message" style={{ color: 'red' }}>{error}</p>}
                <button type="submit" className="login-submit-btn" disabled={loading}>
                    {loading ? 'Logging in...' : 'Log In'}
                </button>
            </form>
            <p style={{ textAlign: 'center', marginTop: '10px' }}>
                <a
                    href="#"
                    onClick={handleResetPassword}
                    style={{ textDecoration: 'underline', color: '#007BFF', cursor: 'pointer' }}
                >
                    Reset Password
                </a>
            </p>
            <button
                className="login-create-account-btn"
                style={{
                    marginTop: '20px',
                    padding: '10px 20px',
                    backgroundColor: '#87CEEB',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    fontSize: '16px'
                }}
                onClick={handleCreateAccount}
            >
                Create New Account
            </button>
        </div>
    );
};

export default LoginPage;